export enum UserType {
    Collaborators = 0,
    AssignedAdmins = 1,
    AssignedQAs = 2,
    AssignedDocControls = 3,
    Reviewers = 4,
    Approvers = 5,
    PeriodicReviewers = 6,
    Author = 7,
    AssignedUser = 8,
    CCImplementationOwner = 9,
    CCCollaborator = 10,
    CCReviewer = 11,
    CCApprover = 12,
    CCVerifier = 13,
    CCInternalClientContact = 14,
    CCNotifiedUser = 15,
    ACAssignees = 16,
    ACVerifiers = 17,
    Owners = 18,
    QualifiedTrainers = 19,
    InternalTrainers = 20,
    HCAssignedUser = 21,
    DocumentInternalClientContacts = 22
}